export default "__VITE_ASSET__DacPAk08__"